var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3235 3.28848C29.1515 2.65287 28.816 2.0734 28.3504 1.60779C27.8848 1.14217 27.3053 0.806642 26.6697 0.634621C24.3428 0 14.9776 0 14.9776 0C14.9776 0 5.61199 0.0192096 3.28504 0.65383C2.64943 0.825862 2.06997 1.16141 1.60437 1.62705C1.13877 2.09269 0.803278 2.67217 0.631303 3.30781C-0.0725432 7.44233 -0.345578 13.7424 0.650629 17.7115C0.822623 18.3471 1.15812 18.9266 1.62372 19.3922C2.08932 19.8578 2.66877 20.1934 3.30437 20.3654C5.63131 21 14.9967 21 14.9967 21C14.9967 21 24.362 21 26.6888 20.3654C27.3244 20.1934 27.9039 19.8579 28.3695 19.3922C28.8352 18.9266 29.1707 18.3471 29.3427 17.7115C30.0851 13.5711 30.3138 7.27495 29.3235 3.28848Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9967 14.9999L19.7658 10.4999L11.9967 5.99994V14.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.40895fdde5376b764cf723498717fae2.svg";
export { ForwardRef as ReactComponent };